var _linearGradient, _linearGradient2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 512,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3ffe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#f0fff4"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 371.5,
    y2: 140.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cffac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b59c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "url(#SVGID_1_)",
    r: 256
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m211.588 211.466h17.765v80.017c0 4.914 3.973 8.891 8.882 8.891h35.529c4.91 0 8.882-3.977 8.882-8.891v-80.017h17.765c3.452 0 6.575-1.997 8.05-5.123 1.457-3.117.989-6.807-1.232-9.464l-44.412-53.345c-3.365-4.046-10.27-4.046-13.636 0l-44.412 53.345c-2.22 2.657-2.689 6.347-1.232 9.464 1.476 3.126 4.599 5.123 8.051 5.123zm186.53 71.126h-71.059c-3.365 0-6.436 1.902-7.946 4.915l-15.301 30.649h-95.624l-15.301-30.649c-1.509-3.013-4.58-4.915-7.946-4.915h-71.059c-4.91 0-8.882 3.977-8.882 8.891v71.126c0 4.914 3.973 8.891 8.882 8.891h284.235c4.91 0 8.882-3.977 8.882-8.891v-71.126c.001-4.915-3.972-8.891-8.881-8.891z",
    fill: "url(#SVGID_2_)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.fee9d7d4f1373c16de3da19f28b22f34.svg";
export { ForwardRef as ReactComponent };